<template>
  <v-container fluid class="itemcategory-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
          centered
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-format-list-bulleted-type</v-icon>
            Item Category
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>

          <v-tab></v-tab>
          <v-tab></v-tab>
          <v-tab></v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit ItemCategory</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemcategorycode')"
                        v-bind:value="initvalue.itemcategorycode"
                        placeholder="Item Category Code"
                        persistent-hint
                        single-line hint="Enter the itemcategory code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemcategoryname')"
                        v-bind:value="initvalue.itemcategoryname"
                        placeholder="ItemCategory Name"
                        persistent-hint
                        single-line hint="Enter the item category name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="itemgroups.map(x => {
                            return {text: x.itemgroupname, value: x._id};
                          })"
                        :value="initvalue.itemgroupid"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemgroupid')"
                        placeholder="Item Group"
                        persistent-hint
                        single-line hint="Please choose the item group">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items=items
                        :value="initvalue.itemcategorytype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'itemcategorytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the itemcategory type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'itemcategorystatus')"
                          v-bind:label="initvalue.itemcategorystatus"
                          v-model="initvalue.itemcategorystatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/itemcategory/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editItemCategory()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/itemcategory/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item></v-tab-item>
          <v-tab-item></v-tab-item>
          <v-tab-item></v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      itemcategory: {},
      detail: {},
      photo: {},
      pin: {
        error: false,
        error2: false
      },
      initvalue: {},
      imageurl: undefined,
      items: ['Item Category', 'Other Item Category'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('ItemCategory', ['updateItemCategoryRequest','updateItemCategoryImageRequest','updateItemCategoryPinRequest','getItemCategorysRequest']),
    ...mapActions('ItemGroup', ['getItemGroupsRequest']),
    editItemCategory() {
      this.itemcategory._id = this.initvalue._id;
      this.updateItemCategoryRequest(this.itemcategory);
      this.getItemCategorysRequest();
      router.push('/itemcategory/list');
    },
    editDetail() {
      this.detail._id = this.initvalue._id;
      this.updateItemCategoryRequest(this.detail);
      this.getItemCategorysRequest();
      router.push('/itemcategory/list');
    },
    editPhoto() {
      console.log(this.photo)
      this.photo._id = this.initvalue._id;
      this.updateItemCategoryImageRequest(this.photo);
      this.getItemCategorysRequest();
      router.push('/itemcategory/list');
    },
    editPin() {
      console.log(this.pin);
      if(this.pin.itemcategorypin == undefined || this.pin.itemcategorypin.length<6){
        this.pin.error = true;
        return;
      }
      this.pin.error = false;
      if(this.pin.itemcategorypin !== this.pin.itemcategorypin2){
        this.pin.error2 = true;
        return;
      }
      this.pin.error2 = false;
      this.pin._id = this.initvalue._id;
      console.log(this.pin);
      this.updateItemCategoryRequest(this.pin);
      this.getItemCategorysRequest();
      router.push('/itemcategory/list');
    },
    updateChangedValue(value, field){
      console.log(value, field);
      this.itemcategory[field] = value;
    },
    updateChangedDetail(value, field){
      console.log(value, field);
      this.detail[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.itemcategoryimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('ItemCategory', ['isReceiving']),
    ...mapState('ItemGroup', ['itemgroups']),
  },
  created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.itemcategoryimage;
    if(!this.initvalue._id) this.$router.push({ name: 'ItemCategoryList' });
    if(this.itemgroups.length==0){this.getItemGroupsRequest()}
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
